import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { Alert, IUiState, ToggleModal, ToggleSidebar } from "./types";

const initialState: IUiState = {
  pinnedSizes: null,
  isDarkMode: true,
  sidebar: null,
  modal: null,
  alert: null,
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    toggleUITheme(state, action: PayloadAction<boolean>) {
      state.isDarkMode = action.payload;
    },
    toggleUISidebar(state, action: PayloadAction<ToggleSidebar>) {
      const {sidebar, value} = action.payload;

      if (typeof value !== 'undefined') {
        state.sidebar = value ? sidebar : null;
      } else {
        state.sidebar = state.sidebar === sidebar ? null : sidebar;
      }
    },
    toggleUIModal(state, action: PayloadAction<ToggleModal>) {
      const {modal, value} = action.payload;

      if (typeof value !== 'undefined') {
        state.modal = value ? modal : null;
      } else {
        state.modal = state.modal === modal ? null : modal;
      }
    },
    toggleUIPinnedSizes(state, action: PayloadAction<IUiState['pinnedSizes']>) {
      state.pinnedSizes = action.payload;
    },
    showUIAlert(state, action: PayloadAction<Omit<Alert, 'visible'>>) {
      state.alert = {
        visible: true,
        ...action.payload,
      };
    },
    hideUIAlert(state) {
      if (state.alert) {
        state.alert.visible = false;
      }
    },
  },
});

export const {
  toggleUIPinnedSizes,
  toggleUISidebar,
  toggleUITheme,
  toggleUIModal,
  showUIAlert,
  hideUIAlert,
} = uiSlice.actions;

export default uiSlice.reducer;
